import { z } from "./zod";

const stringArray = z.array(z.string()).catch([]).transform(values=>[...new Set(values.map(value=>value.trim()).filter(Boolean))]);
const optionalString = z.string().nullable().optional();

export const categorySchema = z.object({
  id: z.string(),
  name: z.string(),
  icon_name: z.string().catch("square.grid.2x2"),
  description: z.string().catch(""),
  color_hex: z.string().catch("2563EB"),
  priority: z.number().catch(0),
  is_featured: z.boolean().catch(false),
  is_premium: z.boolean().catch(false),
  subcategory_ids: stringArray,
});

export const subcategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  icon_name: z.string().catch("folder"),
  description: z.string().catch(""),
  parent_category_id: z.string(),
  priority: z.number().catch(0),
  is_premium: z.boolean().catch(false),
});

export const appSchema = z.object({
  id: z.string(),
  name: z.string(),
  icon_name: z.string().catch("app"),
  bundle_id: optionalString,
  color_hex: z.string().catch("2563EB"),
  description: z.string().catch(""),
  categories: stringArray,
  is_popular: z.boolean().catch(false),
  is_premium: z.boolean().catch(false),
});

export const shortcutSchema = z.object({
  id: z.string(),
  name: z.string(),
  subcategory_ids: stringArray,
  primary_subcategory_id: z.string(),
  short_description: z.string().catch(""),
  detailed_description: z.string().catch(""),
  tags: stringArray,
  required_apps: stringArray,
  app_ids: stringArray,
  is_featured: z.boolean().catch(false),
  is_premium: z.boolean().catch(false),
  install_url: z.string().catch(""),
  image: optionalString,
  device_types: stringArray,
  date_added: z.string().catch(""),
});

export const collectionSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().catch(""),
  icon_name: z.string().catch("rectangle.grid.2x2"),
  color_hex: z.string().catch("2563EB"),
  template_ids: stringArray,
  is_featured: z.boolean().catch(false),
  is_premium: z.boolean().catch(false),
  priority: z.number().catch(0),
});

export const appAliasSchema = z.object({
  alias_id: z.string(),
  canonical_app_id: z.string(),
});

export type Category = z.infer<typeof categorySchema>;
export type Subcategory = z.infer<typeof subcategorySchema>;
export type SupportedApp = z.infer<typeof appSchema>;
export type Shortcut = z.infer<typeof shortcutSchema>;
export type Collection = z.infer<typeof collectionSchema>;
export type AppAlias = z.infer<typeof appAliasSchema>;

export interface Catalog {
  categories: Category[];
  subcategories: Subcategory[];
  apps: SupportedApp[];
  shortcuts: Shortcut[];
  collections: Collection[];
  appAliases: Record<string, string>;
  source: "supabase" | "bundled";
}
